/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Deny_RequestInputs */

const en_document_deny_request = /** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deny`)
};

const id_document_deny_request = /** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolak`)
};

/** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */
const es_document_deny_request = en_document_deny_request;

/** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */
const fr_document_deny_request = en_document_deny_request;

/** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */
const de_document_deny_request = en_document_deny_request;

/** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */
const ja_document_deny_request = en_document_deny_request;

/** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */
const zh_document_deny_request = en_document_deny_request;

/** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */
const ar_document_deny_request = en_document_deny_request;

/** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */
const it_document_deny_request = en_document_deny_request;

/** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */
const ru_document_deny_request = en_document_deny_request;

/** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */
const pt_document_deny_request = en_document_deny_request;

/** @type {(inputs: Document_Deny_RequestInputs) => LocalizedString} */
const ko_document_deny_request = en_document_deny_request;

/**
* | output |
* | --- |
* | "Deny" |
*
* @param {Document_Deny_RequestInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_deny_request = /** @type {((inputs?: Document_Deny_RequestInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Deny_RequestInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_deny_request(inputs)
	if (locale === "es") return es_document_deny_request(inputs)
	if (locale === "fr") return fr_document_deny_request(inputs)
	if (locale === "de") return de_document_deny_request(inputs)
	if (locale === "ja") return ja_document_deny_request(inputs)
	if (locale === "zh") return zh_document_deny_request(inputs)
	if (locale === "ar") return ar_document_deny_request(inputs)
	if (locale === "id") return id_document_deny_request(inputs)
	if (locale === "it") return it_document_deny_request(inputs)
	if (locale === "ru") return ru_document_deny_request(inputs)
	if (locale === "pt") return pt_document_deny_request(inputs)
	return ko_document_deny_request(inputs)
});